import { Shop } from "@/types/v2";

/**
 * Shop fields that encode who owns/can access a shop. They are changed only by
 * the adminReassignShopOwner callable and the claims writers (saveAuthClaims),
 * never by the shop edit form.
 *
 * ShopForm submits `{ ...initialData, ...formValues }` through updateDoc, which
 * REPLACES array fields -- so without scrubbing these, clicking "Update Shop"
 * after a reassignment silently writes the pre-reassignment email, ownerId and
 * *UserIds arrays back over the new ones.
 */
export const OWNERSHIP_MANAGED_SHOP_FIELDS: readonly (keyof Shop)[] = [
  "email",
  "ownerId",
  "users",
  "adminUserIds",
  "technicianUserIds",
  "officeUserIds",
  "viewOnlyUserIds",
];

export function withoutOwnershipFields(shop: Partial<Shop>): Partial<Shop> {
  const copy: Partial<Shop> = { ...shop };
  for (const key of OWNERSHIP_MANAGED_SHOP_FIELDS) {
    delete copy[key];
  }
  return copy;
}
